module.exports = __webpack_public_path__ + "assets/img/Type E (66).9ce65e00.jpg";